import React from "react";
import classNames from "classnames";

import VideoTutorialLink from "components/VideoTutorialLink";

import classes from "./style.module.scss";

export default ({ title, subtitle, className, sideContent, sideContentClasses, videoKey }) => (
    <div className={classNames(classes.sectionHeading, { [className]: className })}>
        <div className={classes.textContent}>
            <h2>{title}</h2>
            {subtitle && <p>{subtitle}</p>}
            {videoKey && <VideoTutorialLink videoKey={videoKey} className={classes.videoTutorialLink} />}
        </div>
        {sideContent && (
            <div className={classNames(classes.sideContent, { [sideContentClasses]: sideContentClasses })}>
                {sideContent}
            </div>
        )}
    </div>
);
